import {Injectable} from '@angular/core';
import {RaDecValidator} from './validators/ra-dec.validator';
import {RegexValidator} from './validators/regex.validator';
import {NumberValidator} from './validators/number.validator';
import {DateValidator} from './validators/date.validator';
import {EclipticAndGalacticValidator} from './validators/ecliptic-galactic.validator';
import {SourceResolverValidator} from "./validators/source-resolver.validator";

export type ElasticValidatorType = 'date' | 'regex' | 'short-regex' | 'number' | 'ra-dec' | 'galactic' | 'ecliptic' | 'source-resolver';

export interface ElasticValidation {
  readonly isInvalid: boolean;
  readonly errorMessage?: string;
}

export interface ElasticValidator {
  validate(value: any): ElasticValidation;
}

@Injectable({providedIn: 'root'})
export class ElasticValidatorFactory {
  getElasticValidator(elasticValidatorType: ElasticValidatorType): ElasticValidator {
    switch (elasticValidatorType) {
      case 'date':
        return new DateValidator();
      case 'number':
        return new NumberValidator();
      case 'ra-dec':
        return new RaDecValidator();
      case 'regex':
        return new RegexValidator();
      case 'short-regex':
        return new RegexValidator(1);
      case 'galactic':
      case 'ecliptic':
        return new EclipticAndGalacticValidator();
      case 'source-resolver':
        return new SourceResolverValidator();
      default:
        return null;
    }
  }
}
